import { SwitchStyles } from '../switch-styles';

export abstract class SwitchModel implements SwitchStyles {
  formControlName?: string;
  id?: string;
  offLabel?: string;
  onLabel?: string;
  labelPosition?: 'top' | 'bottom' | null;
  ariaLabel?: string;
  ariaLabelledby?: string;
  disabled?: boolean;

  labelColor?: string;
  offBackgroundColor?: string;
  onBackgroundColor?: string;
  thumbBackgroundColor?: string;
  labelFontWeight?: number;
  labelFontFamily?: string;
}
